// @flow
import * as React from 'react';
import { translate } from 'react-i18next';
import SelectFilter from 'common/components/SelectFilter';

const DRAFT = 'draft';
const PROPOSED = 'proposed';
const ACCEPTED = 'accepted';
const CANCELLED = 'cancelled';
export const ALL_FILTERS = [DRAFT, PROPOSED, ACCEPTED, CANCELLED];
type Filter = 'draft' | 'proposed' | 'accepted' | 'cancelled';
export type PropositionFilters = Array<Filter>;

function selectionRenderer(t: any, values: PropositionFilters): string {
  switch (values.length) {
    case 0:
      return t('none');
    case 1:
      return t(values[0]);
    case ALL_FILTERS.length:
      return t('all');
    default: {
      const array = values.map(filter => t(filter));
      return array.join(', ');
    }
  }
}

function prepareFilters(selectedFilters?: PropositionFilters, t: any) {
  return ALL_FILTERS.map((filter) => {
    return {
      value: filter,
      text: t(filter),
      selected: selectedFilters && selectedFilters.indexOf(filter) > -1,
    };
  });
}

type Props = {
  selectedFilters?: PropositionFilters,
  onFiltersChange?: (filters: PropositionFilters) => void,
  t: any
};

function PropositionFilter(props: Props) {
  const { selectedFilters, onFiltersChange, t } = props;

  const filters = prepareFilters(selectedFilters, t);

  return (
    <SelectFilter
      filters={filters}
      selectionRenderer={(values: PropositionFilters) => selectionRenderer(t, values)}
      onFiltersChange={(values: PropositionFilters) => onFiltersChange && onFiltersChange(values)}
    />
  );
}

export default translate('commonSales')(PropositionFilter);



// WEBPACK FOOTER //
// ./src/common/modules/proposition/components/PropositionFilter.js